import jsonArrayFieldType from '../../shared/field-types/jsonArray';

export default {
	...jsonArrayFieldType,
	convertToForm(value) {
		if (!value) return [];
		return value;
	}
};
